const getters = {
  hasLogin: state => state.root.user && state.root.user.id,
  user: state => state.root.user,
  token: state => state.root.token,
  route: state => state.root.route,
  faceList: state => state.root.faceList,
  siteID: state => state.root.siteID,
  faceHash: state => state.root.faceHash,
  diGiVideoList: state => state.root.diGiVideoList,
  diGiVideoUrl: state => state.root.diGiVideoUrl
}
export default getters
